// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type ServerSentEventsResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AppControllerGetFrontendConfigData, AppControllerGetFrontendConfigResponses, AppControllerGetVersionData, AppControllerGetVersionResponses, AttributeProviderControllerCreateData, AttributeProviderControllerCreateResponses, AttributeProviderControllerDeleteData, AttributeProviderControllerDeleteErrors, AttributeProviderControllerDeleteResponses, AttributeProviderControllerGetAllData, AttributeProviderControllerGetAllResponses, AttributeProviderControllerGetByIdData, AttributeProviderControllerGetByIdErrors, AttributeProviderControllerGetByIdResponses, AttributeProviderControllerUpdateData, AttributeProviderControllerUpdateErrors, AttributeProviderControllerUpdateResponses, AuditLogControllerGetAuditLogsData, AuditLogControllerGetAuditLogsResponses, AuthControllerGetOAuth2TokenData, AuthControllerGetOAuth2TokenErrors, AuthControllerGetOAuth2TokenResponses, CacheControllerClearAllCachesData, CacheControllerClearAllCachesResponses, CacheControllerClearStatusListCacheData, CacheControllerClearStatusListCacheResponses, CacheControllerClearTrustListCacheData, CacheControllerClearTrustListCacheResponses, CacheControllerGetStatsData, CacheControllerGetStatsResponses, ChainedAsVpControllerAuthorizeData, ChainedAsVpControllerAuthorizeErrors, ChainedAsVpControllerParData, ChainedAsVpControllerParErrors, ChainedAsVpControllerParResponses, ChainedAsVpControllerTokenData, ChainedAsVpControllerTokenErrors, ChainedAsVpControllerTokenResponses, ChainedAsVpControllerVpCallbackData, ChainedAsVpControllerVpCallbackErrors, ClientControllerCreateClientData, ClientControllerCreateClientResponses, ClientControllerDeleteClientData, ClientControllerDeleteClientResponses, ClientControllerGetClientData, ClientControllerGetClientErrors, ClientControllerGetClientResponses, ClientControllerGetClientsData, ClientControllerGetClientsResponses, ClientControllerRotateClientSecretData, ClientControllerRotateClientSecretResponses, ClientControllerUpdateClientData, ClientControllerUpdateClientErrors, ClientControllerUpdateClientResponses, ConfigPortabilityControllerAcknowledgeInterruptionData, ConfigPortabilityControllerAcknowledgeInterruptionResponses, ConfigPortabilityControllerDetachData, ConfigPortabilityControllerDetachResponses, ConfigPortabilityControllerExportData, ConfigPortabilityControllerExportResponses, ConfigPortabilityControllerImportArchiveData, ConfigPortabilityControllerImportArchiveResponses, ConfigPortabilityControllerImportData, ConfigPortabilityControllerImportResponses, ConfigPortabilityControllerOperationData, ConfigPortabilityControllerOperationResponses, ConfigPortabilityControllerOperationsData, ConfigPortabilityControllerOperationsResponses, ConfigPortabilityControllerPlanArchiveData, ConfigPortabilityControllerPlanArchiveResponses, ConfigPortabilityControllerPlanData, ConfigPortabilityControllerPlanResponses, ConfigPortabilityControllerResourcesData, ConfigPortabilityControllerResourcesResponses, ConfigPortabilityControllerUpgradeData, ConfigPortabilityControllerUpgradeResponses, CredentialConfigControllerDeleteIssuanceConfigurationData, CredentialConfigControllerDeleteIssuanceConfigurationResponses, CredentialConfigControllerGetConfigByIdData, CredentialConfigControllerGetConfigByIdResponses, CredentialConfigControllerGetConfigsData, CredentialConfigControllerGetConfigsResponses, CredentialConfigControllerStoreCredentialConfigurationData, CredentialConfigControllerStoreCredentialConfigurationResponses, CredentialConfigControllerUpdateCredentialConfigurationData, CredentialConfigControllerUpdateCredentialConfigurationResponses, CredentialOfferControllerGetOfferData, CredentialOfferControllerGetOfferResponses, DeferredControllerCompleteDeferredData, DeferredControllerCompleteDeferredErrors, DeferredControllerCompleteDeferredResponses, DeferredControllerFailDeferredData, DeferredControllerFailDeferredErrors, DeferredControllerFailDeferredResponses, IssuanceConfigControllerGetIssuanceConfigurationsData, IssuanceConfigControllerGetIssuanceConfigurationsResponses, IssuanceConfigControllerReissueRegistrationCertificateData, IssuanceConfigControllerReissueRegistrationCertificateErrors, IssuanceConfigControllerReissueRegistrationCertificateResponses, IssuanceConfigControllerStoreIssuanceConfigurationData, IssuanceConfigControllerStoreIssuanceConfigurationResponses, KeyChainControllerCreateData, KeyChainControllerCreateResponses, KeyChainControllerDeleteData, KeyChainControllerDeleteErrors, KeyChainControllerDeleteResponses, KeyChainControllerDeleteTenantKmsConfigData, KeyChainControllerDeleteTenantKmsConfigResponses, KeyChainControllerExportData, KeyChainControllerExportErrors, KeyChainControllerExportResponses, KeyChainControllerGetAllData, KeyChainControllerGetAllResponses, KeyChainControllerGetByIdData, KeyChainControllerGetByIdErrors, KeyChainControllerGetByIdResponses, KeyChainControllerGetProvidersData, KeyChainControllerGetProvidersHealthData, KeyChainControllerGetProvidersHealthResponses, KeyChainControllerGetProvidersResponses, KeyChainControllerGetTenantKmsConfigData, KeyChainControllerGetTenantKmsConfigResponses, KeyChainControllerImportData, KeyChainControllerImportResponses, KeyChainControllerRotateData, KeyChainControllerRotateErrors, KeyChainControllerRotateResponses, KeyChainControllerUpdateData, KeyChainControllerUpdateErrors, KeyChainControllerUpdateResponses, KeyChainControllerUpdateTenantKmsConfigData, KeyChainControllerUpdateTenantKmsConfigResponses, PresentationManagementControllerConfigurationData, PresentationManagementControllerConfigurationResponses, PresentationManagementControllerDeleteConfigurationData, PresentationManagementControllerDeleteConfigurationResponses, PresentationManagementControllerGetConfigurationData, PresentationManagementControllerGetConfigurationResponses, PresentationManagementControllerListSchemaMetadataCatalogData, PresentationManagementControllerListSchemaMetadataCatalogResponses, PresentationManagementControllerReissueRegistrationCertificateData, PresentationManagementControllerReissueRegistrationCertificateErrors, PresentationManagementControllerReissueRegistrationCertificateResponses, PresentationManagementControllerResolveIssuerMetadataData, PresentationManagementControllerResolveIssuerMetadataErrors, PresentationManagementControllerResolveIssuerMetadataResponses, PresentationManagementControllerResolveSchemaMetadataData, PresentationManagementControllerResolveSchemaMetadataErrors, PresentationManagementControllerResolveSchemaMetadataJwtData, PresentationManagementControllerResolveSchemaMetadataJwtErrors, PresentationManagementControllerResolveSchemaMetadataJwtResponses, PresentationManagementControllerResolveSchemaMetadataResponses, PresentationManagementControllerStorePresentationConfigData, PresentationManagementControllerStorePresentationConfigResponses, PresentationManagementControllerUpdateConfigurationData, PresentationManagementControllerUpdateConfigurationResponses, RegistrarControllerCreateAccessCertificateData, RegistrarControllerCreateAccessCertificateErrors, RegistrarControllerCreateAccessCertificateResponses, RegistrarControllerCreateConfigData, RegistrarControllerCreateConfigErrors, RegistrarControllerCreateConfigResponses, RegistrarControllerDeleteConfigData, RegistrarControllerDeleteConfigResponses, RegistrarControllerGetConfigData, RegistrarControllerGetConfigErrors, RegistrarControllerGetConfigResponses, RegistrarControllerUpdateConfigData, RegistrarControllerUpdateConfigErrors, RegistrarControllerUpdateConfigResponses, SchemaMetadataControllerDeprecateVersionData, SchemaMetadataControllerDeprecateVersionResponses, SchemaMetadataControllerFindAllData, SchemaMetadataControllerFindAllResponses, SchemaMetadataControllerFindOneData, SchemaMetadataControllerFindOneResponses, SchemaMetadataControllerGetJwtData, SchemaMetadataControllerGetJwtResponses, SchemaMetadataControllerGetLatestData, SchemaMetadataControllerGetLatestResponses, SchemaMetadataControllerGetMineData, SchemaMetadataControllerGetMineResponses, SchemaMetadataControllerGetSchemaData, SchemaMetadataControllerGetSchemaResponses, SchemaMetadataControllerGetVersionsData, SchemaMetadataControllerGetVersionsResponses, SchemaMetadataControllerGetVocabulariesData, SchemaMetadataControllerGetVocabulariesResponses, SchemaMetadataControllerPublishSchemaMetadataData, SchemaMetadataControllerPublishSchemaMetadataErrors, SchemaMetadataControllerPublishSchemaMetadataResponses, SchemaMetadataControllerPublishSchemaMetadataVersionData, SchemaMetadataControllerPublishSchemaMetadataVersionErrors, SchemaMetadataControllerPublishSchemaMetadataVersionResponses, SchemaMetadataControllerRemoveData, SchemaMetadataControllerRemoveResponses, SchemaMetadataControllerUpdateData, SchemaMetadataControllerUpdateResponses, SessionConfigControllerGetConfigData, SessionConfigControllerGetConfigResponses, SessionConfigControllerResetConfigData, SessionConfigControllerResetConfigResponses, SessionConfigControllerUpdateConfigData, SessionConfigControllerUpdateConfigResponses, SessionControllerDeleteSessionData, SessionControllerDeleteSessionResponses, SessionControllerGetAllSessionsData, SessionControllerGetAllSessionsResponses, SessionControllerGetSessionData, SessionControllerGetSessionLogsData, SessionControllerGetSessionLogsResponses, SessionControllerGetSessionResponses, SessionControllerRevokeAllData, SessionControllerRevokeAllResponses, SessionEventsControllerSubscribeToSessionEventsData, SessionEventsControllerSubscribeToSessionEventsResponse, SessionEventsControllerSubscribeToSessionEventsResponses, StatusListConfigControllerGetConfigData, StatusListConfigControllerGetConfigResponses, StatusListConfigControllerResetConfigData, StatusListConfigControllerResetConfigResponses, StatusListConfigControllerUpdateConfigData, StatusListConfigControllerUpdateConfigResponses, StatusListManagementControllerCreateListData, StatusListManagementControllerCreateListResponses, StatusListManagementControllerDeleteListData, StatusListManagementControllerDeleteListResponses, StatusListManagementControllerGetListData, StatusListManagementControllerGetListResponses, StatusListManagementControllerGetListsData, StatusListManagementControllerGetListsResponses, StatusListManagementControllerUpdateListData, StatusListManagementControllerUpdateListResponses, StorageControllerUploadData, StorageControllerUploadResponses, TenantControllerDeleteTenantData, TenantControllerDeleteTenantResponses, TenantControllerGetTenantData, TenantControllerGetTenantResponses, TenantControllerGetTenantsData, TenantControllerGetTenantsResponses, TenantControllerInitTenantData, TenantControllerInitTenantResponses, TenantControllerUpdateTenantData, TenantControllerUpdateTenantResponses, TrustListControllerCreateTrustListData, TrustListControllerCreateTrustListResponses, TrustListControllerDeleteTrustListData, TrustListControllerDeleteTrustListResponses, TrustListControllerExportTrustListData, TrustListControllerExportTrustListResponses, TrustListControllerGetAllTrustListsData, TrustListControllerGetAllTrustListsResponses, TrustListControllerGetTrustListData, TrustListControllerGetTrustListResponses, TrustListControllerGetTrustListVersionData, TrustListControllerGetTrustListVersionResponses, TrustListControllerGetTrustListVersionsData, TrustListControllerGetTrustListVersionsResponses, TrustListControllerUpdateTrustListData, TrustListControllerUpdateTrustListResponses, UserControllerCreateUserData, UserControllerCreateUserResponses, UserControllerDeleteUserData, UserControllerDeleteUserResponses, UserControllerGetUserData, UserControllerGetUserResponses, UserControllerGetUsersData, UserControllerGetUsersResponses, UserControllerUpdateUserData, UserControllerUpdateUserResponses, VerifierOfferControllerGetOfferData, VerifierOfferControllerGetOfferResponses, WebhookEndpointControllerCreateData, WebhookEndpointControllerCreateResponses, WebhookEndpointControllerDeleteData, WebhookEndpointControllerDeleteErrors, WebhookEndpointControllerDeleteResponses, WebhookEndpointControllerGetAllData, WebhookEndpointControllerGetAllResponses, WebhookEndpointControllerGetByIdData, WebhookEndpointControllerGetByIdErrors, WebhookEndpointControllerGetByIdResponses, WebhookEndpointControllerUpdateData, WebhookEndpointControllerUpdateErrors, WebhookEndpointControllerUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get service version
 */
export const appControllerGetVersion = <ThrowOnError extends boolean = true>(options?: Options<AppControllerGetVersionData, ThrowOnError>): RequestResult<AppControllerGetVersionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AppControllerGetVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/version',
    ...options
});

/**
 * Get frontend runtime configuration
 */
export const appControllerGetFrontendConfig = <ThrowOnError extends boolean = true>(options?: Options<AppControllerGetFrontendConfigData, ThrowOnError>): RequestResult<AppControllerGetFrontendConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AppControllerGetFrontendConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/frontend-config',
    ...options
});

/**
 * OAuth2 Token endpoint - supports client credentials flow only
 * Accepts client credentials either in Authorization header (Basic auth) or request body
 */
export const authControllerGetOAuth2Token = <ThrowOnError extends boolean = true>(options: Options<AuthControllerGetOAuth2TokenData, ThrowOnError>): RequestResult<AuthControllerGetOAuth2TokenResponses, AuthControllerGetOAuth2TokenErrors, ThrowOnError> => (options.client ?? client).post<AuthControllerGetOAuth2TokenResponses, AuthControllerGetOAuth2TokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/oauth2/token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Get all tenants
 */
export const tenantControllerGetTenants = <ThrowOnError extends boolean = true>(options?: Options<TenantControllerGetTenantsData, ThrowOnError>): RequestResult<TenantControllerGetTenantsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TenantControllerGetTenantsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant',
    ...options
});

/**
 * Initialize a tenant
 */
export const tenantControllerInitTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerInitTenantData, ThrowOnError>): RequestResult<TenantControllerInitTenantResponses, unknown, ThrowOnError> => (options.client ?? client).post<TenantControllerInitTenantResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a tenant by ID
 */
export const tenantControllerDeleteTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerDeleteTenantData, ThrowOnError>): RequestResult<TenantControllerDeleteTenantResponses, unknown, ThrowOnError> => (options.client ?? client).delete<TenantControllerDeleteTenantResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant/{id}',
    ...options
});

/**
 * Get a tenant by ID
 */
export const tenantControllerGetTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerGetTenantData, ThrowOnError>): RequestResult<TenantControllerGetTenantResponses, unknown, ThrowOnError> => (options.client ?? client).get<TenantControllerGetTenantResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant/{id}',
    ...options
});

/**
 * Update a tenant by ID
 */
export const tenantControllerUpdateTenant = <ThrowOnError extends boolean = true>(options: Options<TenantControllerUpdateTenantData, ThrowOnError>): RequestResult<TenantControllerUpdateTenantResponses, unknown, ThrowOnError> => (options.client ?? client).patch<TenantControllerUpdateTenantResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tenant/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get recent audit log entries for the current tenant
 */
export const auditLogControllerGetAuditLogs = <ThrowOnError extends boolean = true>(options?: Options<AuditLogControllerGetAuditLogsData, ThrowOnError>): RequestResult<AuditLogControllerGetAuditLogsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuditLogControllerGetAuditLogsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/audit-logs',
    ...options
});

/**
 * Get all clients for the current tenant
 */
export const clientControllerGetClients = <ThrowOnError extends boolean = true>(options?: Options<ClientControllerGetClientsData, ThrowOnError>): RequestResult<ClientControllerGetClientsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ClientControllerGetClientsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client',
    ...options
});

/**
 * Create a new client
 */
export const clientControllerCreateClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerCreateClientData, ThrowOnError>): RequestResult<ClientControllerCreateClientResponses, unknown, ThrowOnError> => (options.client ?? client).post<ClientControllerCreateClientResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a client
 */
export const clientControllerDeleteClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerDeleteClientData, ThrowOnError>): RequestResult<ClientControllerDeleteClientResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ClientControllerDeleteClientResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}',
    ...options
});

/**
 * Get a client by its id
 */
export const clientControllerGetClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerGetClientData, ThrowOnError>): RequestResult<ClientControllerGetClientResponses, ClientControllerGetClientErrors, ThrowOnError> => (options.client ?? client).get<ClientControllerGetClientResponses, ClientControllerGetClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}',
    ...options
});

/**
 * Update a client by its id
 */
export const clientControllerUpdateClient = <ThrowOnError extends boolean = true>(options: Options<ClientControllerUpdateClientData, ThrowOnError>): RequestResult<ClientControllerUpdateClientResponses, ClientControllerUpdateClientErrors, ThrowOnError> => (options.client ?? client).patch<ClientControllerUpdateClientResponses, ClientControllerUpdateClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate (regenerate) a client's secret.
 * Returns the new secret for one-time display - save it immediately!
 *
 * Users with `tenants:manage` role can rotate secrets for any client.
 * Users with `clients:manage` role can only rotate secrets for clients in their tenant.
 */
export const clientControllerRotateClientSecret = <ThrowOnError extends boolean = true>(options: Options<ClientControllerRotateClientSecretData, ThrowOnError>): RequestResult<ClientControllerRotateClientSecretResponses, unknown, ThrowOnError> => (options.client ?? client).post<ClientControllerRotateClientSecretResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client/{id}/rotate-secret',
    ...options
});

/**
 * Delete registrar configuration
 */
export const registrarControllerDeleteConfig = <ThrowOnError extends boolean = true>(options?: Options<RegistrarControllerDeleteConfigData, ThrowOnError>): RequestResult<RegistrarControllerDeleteConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<RegistrarControllerDeleteConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options
});

/**
 * Get registrar configuration
 */
export const registrarControllerGetConfig = <ThrowOnError extends boolean = true>(options?: Options<RegistrarControllerGetConfigData, ThrowOnError>): RequestResult<RegistrarControllerGetConfigResponses, RegistrarControllerGetConfigErrors, ThrowOnError> => (options?.client ?? client).get<RegistrarControllerGetConfigResponses, RegistrarControllerGetConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options
});

/**
 * Update registrar configuration
 */
export const registrarControllerUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<RegistrarControllerUpdateConfigData, ThrowOnError>): RequestResult<RegistrarControllerUpdateConfigResponses, RegistrarControllerUpdateConfigErrors, ThrowOnError> => (options.client ?? client).patch<RegistrarControllerUpdateConfigResponses, RegistrarControllerUpdateConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or replace registrar configuration
 */
export const registrarControllerCreateConfig = <ThrowOnError extends boolean = true>(options: Options<RegistrarControllerCreateConfigData, ThrowOnError>): RequestResult<RegistrarControllerCreateConfigResponses, RegistrarControllerCreateConfigErrors, ThrowOnError> => (options.client ?? client).post<RegistrarControllerCreateConfigResponses, RegistrarControllerCreateConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an access certificate for a key
 *
 * Creates an access certificate at the registrar for the specified key. Requires a relying party to be already registered at the registrar. The certificate is automatically stored in EUDIPLO.
 */
export const registrarControllerCreateAccessCertificate = <ThrowOnError extends boolean = true>(options: Options<RegistrarControllerCreateAccessCertificateData, ThrowOnError>): RequestResult<RegistrarControllerCreateAccessCertificateResponses, RegistrarControllerCreateAccessCertificateErrors, ThrowOnError> => (options.client ?? client).post<RegistrarControllerCreateAccessCertificateResponses, RegistrarControllerCreateAccessCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/registrar/access-certificate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all managed users for the current tenant
 */
export const userControllerGetUsers = <ThrowOnError extends boolean = true>(options?: Options<UserControllerGetUsersData, ThrowOnError>): RequestResult<UserControllerGetUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserControllerGetUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options
});

/**
 * Create a new managed user
 */
export const userControllerCreateUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerCreateUserData, ThrowOnError>): RequestResult<UserControllerCreateUserResponses, unknown, ThrowOnError> => (options.client ?? client).post<UserControllerCreateUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a managed user
 */
export const userControllerDeleteUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerDeleteUserData, ThrowOnError>): RequestResult<UserControllerDeleteUserResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UserControllerDeleteUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options
});

/**
 * Get a managed user by id
 */
export const userControllerGetUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerGetUserData, ThrowOnError>): RequestResult<UserControllerGetUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<UserControllerGetUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options
});

/**
 * Update a managed user
 */
export const userControllerUpdateUser = <ThrowOnError extends boolean = true>(options: Options<UserControllerUpdateUserData, ThrowOnError>): RequestResult<UserControllerUpdateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UserControllerUpdateUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get available KMS providers
 */
export const keyChainControllerGetProviders = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetProvidersData, ThrowOnError>): RequestResult<KeyChainControllerGetProvidersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetProvidersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers',
    ...options
});

/**
 * Health probe for every KMS provider
 */
export const keyChainControllerGetProvidersHealth = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetProvidersHealthData, ThrowOnError>): RequestResult<KeyChainControllerGetProvidersHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetProvidersHealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/health',
    ...options
});

/**
 * Delete tenant KMS provider configuration
 *
 * Removes <CONFIG_FOLDER>/<tenantId>/kms.json and falls back to global KMS config.
 */
export const keyChainControllerDeleteTenantKmsConfig = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerDeleteTenantKmsConfigData, ThrowOnError>): RequestResult<KeyChainControllerDeleteTenantKmsConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<KeyChainControllerDeleteTenantKmsConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/config',
    ...options
});

/**
 * Get tenant KMS provider configuration
 *
 * Returns tenant-specific KMS config (if present) and the effective merged runtime config.
 */
export const keyChainControllerGetTenantKmsConfig = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetTenantKmsConfigData, ThrowOnError>): RequestResult<KeyChainControllerGetTenantKmsConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetTenantKmsConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/config',
    ...options
});

/**
 * Create or replace tenant KMS provider configuration
 */
export const keyChainControllerUpdateTenantKmsConfig = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerUpdateTenantKmsConfigData, ThrowOnError>): RequestResult<KeyChainControllerUpdateTenantKmsConfigResponses, unknown, ThrowOnError> => (options.client ?? client).put<KeyChainControllerUpdateTenantKmsConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/providers/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List user-manageable signing key chains for the tenant
 */
export const keyChainControllerGetAll = <ThrowOnError extends boolean = true>(options?: Options<KeyChainControllerGetAllData, ThrowOnError>): RequestResult<KeyChainControllerGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<KeyChainControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain',
    ...options
});

/**
 * Create a new key chain
 */
export const keyChainControllerCreate = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerCreateData, ThrowOnError>): RequestResult<KeyChainControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<KeyChainControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a key chain
 */
export const keyChainControllerDelete = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerDeleteData, ThrowOnError>): RequestResult<KeyChainControllerDeleteResponses, KeyChainControllerDeleteErrors, ThrowOnError> => (options.client ?? client).delete<KeyChainControllerDeleteResponses, KeyChainControllerDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}',
    ...options
});

/**
 * Get a key chain by ID
 */
export const keyChainControllerGetById = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerGetByIdData, ThrowOnError>): RequestResult<KeyChainControllerGetByIdResponses, KeyChainControllerGetByIdErrors, ThrowOnError> => (options.client ?? client).get<KeyChainControllerGetByIdResponses, KeyChainControllerGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}',
    ...options
});

/**
 * Update key chain metadata and rotation policy
 */
export const keyChainControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerUpdateData, ThrowOnError>): RequestResult<KeyChainControllerUpdateResponses, KeyChainControllerUpdateErrors, ThrowOnError> => (options.client ?? client).put<KeyChainControllerUpdateResponses, KeyChainControllerUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export a key chain in config-import format
 *
 * Returns the key chain including private key material in the same format used by config import JSON files.
 */
export const keyChainControllerExport = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerExportData, ThrowOnError>): RequestResult<KeyChainControllerExportResponses, KeyChainControllerExportErrors, ThrowOnError> => (options.client ?? client).get<KeyChainControllerExportResponses, KeyChainControllerExportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}/export',
    ...options
});

/**
 * Import an existing key chain
 */
export const keyChainControllerImport = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerImportData, ThrowOnError>): RequestResult<KeyChainControllerImportResponses, unknown, ThrowOnError> => (options.client ?? client).post<KeyChainControllerImportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate the signing key in a key chain
 */
export const keyChainControllerRotate = <ThrowOnError extends boolean = true>(options: Options<KeyChainControllerRotateData, ThrowOnError>): RequestResult<KeyChainControllerRotateResponses, KeyChainControllerRotateErrors, ThrowOnError> => (options.client ?? client).post<KeyChainControllerRotateResponses, KeyChainControllerRotateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/key-chain/{id}/rotate',
    ...options
});

/**
 * List all attribute providers
 */
export const attributeProviderControllerGetAll = <ThrowOnError extends boolean = true>(options?: Options<AttributeProviderControllerGetAllData, ThrowOnError>): RequestResult<AttributeProviderControllerGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AttributeProviderControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers',
    ...options
});

/**
 * Create a new attribute provider
 */
export const attributeProviderControllerCreate = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerCreateData, ThrowOnError>): RequestResult<AttributeProviderControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AttributeProviderControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an attribute provider
 */
export const attributeProviderControllerDelete = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerDeleteData, ThrowOnError>): RequestResult<AttributeProviderControllerDeleteResponses, AttributeProviderControllerDeleteErrors, ThrowOnError> => (options.client ?? client).delete<AttributeProviderControllerDeleteResponses, AttributeProviderControllerDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers/{id}',
    ...options
});

/**
 * Get an attribute provider by ID
 */
export const attributeProviderControllerGetById = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerGetByIdData, ThrowOnError>): RequestResult<AttributeProviderControllerGetByIdResponses, AttributeProviderControllerGetByIdErrors, ThrowOnError> => (options.client ?? client).get<AttributeProviderControllerGetByIdResponses, AttributeProviderControllerGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers/{id}',
    ...options
});

/**
 * Update an attribute provider
 */
export const attributeProviderControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<AttributeProviderControllerUpdateData, ThrowOnError>): RequestResult<AttributeProviderControllerUpdateResponses, AttributeProviderControllerUpdateErrors, ThrowOnError> => (options.client ?? client).patch<AttributeProviderControllerUpdateResponses, AttributeProviderControllerUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/attribute-providers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get sessions (paginated)
 */
export const sessionControllerGetAllSessions = <ThrowOnError extends boolean = true>(options?: Options<SessionControllerGetAllSessionsData, ThrowOnError>): RequestResult<SessionControllerGetAllSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SessionControllerGetAllSessionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session',
    ...options
});

/**
 * Deletes a session by its ID
 */
export const sessionControllerDeleteSession = <ThrowOnError extends boolean = true>(options: Options<SessionControllerDeleteSessionData, ThrowOnError>): RequestResult<SessionControllerDeleteSessionResponses, unknown, ThrowOnError> => (options.client ?? client).delete<SessionControllerDeleteSessionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}',
    ...options
});

/**
 * Retrieves the session information for a given session ID.
 */
export const sessionControllerGetSession = <ThrowOnError extends boolean = true>(options: Options<SessionControllerGetSessionData, ThrowOnError>): RequestResult<SessionControllerGetSessionResponses, unknown, ThrowOnError> => (options.client ?? client).get<SessionControllerGetSessionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}',
    ...options
});

/**
 * Get session log entries
 */
export const sessionControllerGetSessionLogs = <ThrowOnError extends boolean = true>(options: Options<SessionControllerGetSessionLogsData, ThrowOnError>): RequestResult<SessionControllerGetSessionLogsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SessionControllerGetSessionLogsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/{id}/logs',
    ...options
});

/**
 * Update the status of the credentials of a specific session.
 */
export const sessionControllerRevokeAll = <ThrowOnError extends boolean = true>(options: Options<SessionControllerRevokeAllData, ThrowOnError>): RequestResult<SessionControllerRevokeAllResponses, unknown, ThrowOnError> => (options.client ?? client).post<SessionControllerRevokeAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset session storage configuration
 *
 * Resets the session storage configuration to use global defaults.
 */
export const sessionConfigControllerResetConfig = <ThrowOnError extends boolean = true>(options?: Options<SessionConfigControllerResetConfigData, ThrowOnError>): RequestResult<SessionConfigControllerResetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<SessionConfigControllerResetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session-config',
    ...options
});

/**
 * Get session storage configuration
 *
 * Returns the session storage configuration for the current tenant.
 */
export const sessionConfigControllerGetConfig = <ThrowOnError extends boolean = true>(options?: Options<SessionConfigControllerGetConfigData, ThrowOnError>): RequestResult<SessionConfigControllerGetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SessionConfigControllerGetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session-config',
    ...options
});

/**
 * Update session storage configuration
 *
 * Updates the session storage configuration for the current tenant.
 */
export const sessionConfigControllerUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<SessionConfigControllerUpdateConfigData, ThrowOnError>): RequestResult<SessionConfigControllerUpdateConfigResponses, unknown, ThrowOnError> => (options.client ?? client).put<SessionConfigControllerUpdateConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/session-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Subscribe to session status updates
 *
 * Server-Sent Events endpoint for real-time session status updates. Requires JWT authentication via query parameter.
 */
export const sessionEventsControllerSubscribeToSessionEvents = <ThrowOnError extends boolean = true>(options: Options<SessionEventsControllerSubscribeToSessionEventsData, ThrowOnError, SessionEventsControllerSubscribeToSessionEventsResponse>): Promise<ServerSentEventsResult<SessionEventsControllerSubscribeToSessionEventsResponses>> => (options.client ?? client).sse.get<SessionEventsControllerSubscribeToSessionEventsResponses, unknown, ThrowOnError>({ url: '/api/session/{id}/events', ...options });

/**
 * Reset status list configuration
 *
 * Reset the status list configuration to global defaults. Only affects newly created status lists.
 */
export const statusListConfigControllerResetConfig = <ThrowOnError extends boolean = true>(options?: Options<StatusListConfigControllerResetConfigData, ThrowOnError>): RequestResult<StatusListConfigControllerResetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<StatusListConfigControllerResetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-list-config',
    ...options
});

/**
 * Get status list configuration
 *
 * Returns the current status list configuration for the tenant. Fields not set use global defaults.
 */
export const statusListConfigControllerGetConfig = <ThrowOnError extends boolean = true>(options?: Options<StatusListConfigControllerGetConfigData, ThrowOnError>): RequestResult<StatusListConfigControllerGetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StatusListConfigControllerGetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-list-config',
    ...options
});

/**
 * Update status list configuration
 *
 * Update the status list configuration. Changes only affect newly created status lists. Set a field to null to reset to global default.
 */
export const statusListConfigControllerUpdateConfig = <ThrowOnError extends boolean = true>(options: Options<StatusListConfigControllerUpdateConfigData, ThrowOnError>): RequestResult<StatusListConfigControllerUpdateConfigResponses, unknown, ThrowOnError> => (options.client ?? client).put<StatusListConfigControllerUpdateConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-list-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all status lists
 *
 * Returns all status lists for the tenant, including their capacity and usage.
 */
export const statusListManagementControllerGetLists = <ThrowOnError extends boolean = true>(options?: Options<StatusListManagementControllerGetListsData, ThrowOnError>): RequestResult<StatusListManagementControllerGetListsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<StatusListManagementControllerGetListsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists',
    ...options
});

/**
 * Create a status list
 *
 * Creates a new status list. Optionally bind it to a specific credential configuration and/or certificate.
 */
export const statusListManagementControllerCreateList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerCreateListData, ThrowOnError>): RequestResult<StatusListManagementControllerCreateListResponses, unknown, ThrowOnError> => (options.client ?? client).post<StatusListManagementControllerCreateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a status list
 *
 * Delete a status list. Only allowed if no credentials are using it.
 */
export const statusListManagementControllerDeleteList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerDeleteListData, ThrowOnError>): RequestResult<StatusListManagementControllerDeleteListResponses, unknown, ThrowOnError> => (options.client ?? client).delete<StatusListManagementControllerDeleteListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists/{listId}',
    ...options
});

/**
 * Get a status list
 *
 * Returns details for a specific status list.
 */
export const statusListManagementControllerGetList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerGetListData, ThrowOnError>): RequestResult<StatusListManagementControllerGetListResponses, unknown, ThrowOnError> => (options.client ?? client).get<StatusListManagementControllerGetListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists/{listId}',
    ...options
});

/**
 * Update a status list
 *
 * Update a status list's credential configuration binding and/or certificate.
 */
export const statusListManagementControllerUpdateList = <ThrowOnError extends boolean = true>(options: Options<StatusListManagementControllerUpdateListData, ThrowOnError>): RequestResult<StatusListManagementControllerUpdateListResponses, unknown, ThrowOnError> => (options.client ?? client).patch<StatusListManagementControllerUpdateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/status-lists/{listId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List credential configurations
 */
export const credentialConfigControllerGetConfigs = <ThrowOnError extends boolean = true>(options?: Options<CredentialConfigControllerGetConfigsData, ThrowOnError>): RequestResult<CredentialConfigControllerGetConfigsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CredentialConfigControllerGetConfigsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials',
    ...options
});

/**
 * Create a credential configuration
 */
export const credentialConfigControllerStoreCredentialConfiguration = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerStoreCredentialConfigurationData, ThrowOnError>): RequestResult<CredentialConfigControllerStoreCredentialConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).post<CredentialConfigControllerStoreCredentialConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a credential configuration
 */
export const credentialConfigControllerDeleteIssuanceConfiguration = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerDeleteIssuanceConfigurationData, ThrowOnError>): RequestResult<CredentialConfigControllerDeleteIssuanceConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CredentialConfigControllerDeleteIssuanceConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials/{id}',
    ...options
});

/**
 * Get a credential configuration by ID
 */
export const credentialConfigControllerGetConfigById = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerGetConfigByIdData, ThrowOnError>): RequestResult<CredentialConfigControllerGetConfigByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<CredentialConfigControllerGetConfigByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials/{id}',
    ...options
});

/**
 * Update a credential configuration
 */
export const credentialConfigControllerUpdateCredentialConfiguration = <ThrowOnError extends boolean = true>(options: Options<CredentialConfigControllerUpdateCredentialConfigurationData, ThrowOnError>): RequestResult<CredentialConfigControllerUpdateCredentialConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<CredentialConfigControllerUpdateCredentialConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/credentials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Returns the presentation request configurations.
 */
export const presentationManagementControllerConfiguration = <ThrowOnError extends boolean = true>(options?: Options<PresentationManagementControllerConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerConfigurationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PresentationManagementControllerConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config',
    ...options
});

/**
 * Store a presentation request configuration. If it already exists, it will be updated.
 */
export const presentationManagementControllerStorePresentationConfig = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerStorePresentationConfigData, ThrowOnError>): RequestResult<PresentationManagementControllerStorePresentationConfigResponses, unknown, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerStorePresentationConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve external issuer metadata
 *
 * Fetches OpenID4VCI credential issuer metadata from an external issuer URL on the server side.
 */
export const presentationManagementControllerResolveIssuerMetadata = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerResolveIssuerMetadataData, ThrowOnError>): RequestResult<PresentationManagementControllerResolveIssuerMetadataResponses, PresentationManagementControllerResolveIssuerMetadataErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerResolveIssuerMetadataResponses, PresentationManagementControllerResolveIssuerMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/issuer-metadata/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve external schema metadata
 *
 * Fetches schema metadata from an external URL, extracts signedJwt, validates the JWT payload shape and returns normalized fields for presentation config import.
 */
export const presentationManagementControllerResolveSchemaMetadata = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerResolveSchemaMetadataData, ThrowOnError>): RequestResult<PresentationManagementControllerResolveSchemaMetadataResponses, PresentationManagementControllerResolveSchemaMetadataErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerResolveSchemaMetadataResponses, PresentationManagementControllerResolveSchemaMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/schema-metadata/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve schema metadata JWT
 *
 * Validates and resolves a signed schema metadata JWT directly, building DCQL and resolving schema references. Useful for resolving catalog entries without requiring external URL accessibility.
 */
export const presentationManagementControllerResolveSchemaMetadataJwt = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerResolveSchemaMetadataJwtData, ThrowOnError>): RequestResult<PresentationManagementControllerResolveSchemaMetadataJwtResponses, PresentationManagementControllerResolveSchemaMetadataJwtErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerResolveSchemaMetadataJwtResponses, PresentationManagementControllerResolveSchemaMetadataJwtErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/schema-metadata/resolve-jwt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List schema metadata from the registrar catalog
 *
 * Returns all schema metadata entries from the configured registrar. Returns an empty array when no registrar is configured.
 */
export const presentationManagementControllerListSchemaMetadataCatalog = <ThrowOnError extends boolean = true>(options?: Options<PresentationManagementControllerListSchemaMetadataCatalogData, ThrowOnError>): RequestResult<PresentationManagementControllerListSchemaMetadataCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PresentationManagementControllerListSchemaMetadataCatalogResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/schema-metadata/catalog',
    ...options
});

/**
 * Deletes a presentation request configuration by its ID.
 */
export const presentationManagementControllerDeleteConfiguration = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerDeleteConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerDeleteConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<PresentationManagementControllerDeleteConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}',
    ...options
});

/**
 * Get a presentation request configuration by its ID.
 */
export const presentationManagementControllerGetConfiguration = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerGetConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerGetConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).get<PresentationManagementControllerGetConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}',
    ...options
});

/**
 * Update a presentation request configuration by its ID.
 */
export const presentationManagementControllerUpdateConfiguration = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerUpdateConfigurationData, ThrowOnError>): RequestResult<PresentationManagementControllerUpdateConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PresentationManagementControllerUpdateConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reissue the registration certificate cache
 *
 * Bypasses the embedded registration-certificate cache and re-resolves it from the configured registrar.
 */
export const presentationManagementControllerReissueRegistrationCertificate = <ThrowOnError extends boolean = true>(options: Options<PresentationManagementControllerReissueRegistrationCertificateData, ThrowOnError>): RequestResult<PresentationManagementControllerReissueRegistrationCertificateResponses, PresentationManagementControllerReissueRegistrationCertificateErrors, ThrowOnError> => (options.client ?? client).post<PresentationManagementControllerReissueRegistrationCertificateResponses, PresentationManagementControllerReissueRegistrationCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/config/{id}/registration-cert/reissue',
    ...options
});

/**
 * Returns all trust lists for the tenant
 */
export const trustListControllerGetAllTrustLists = <ThrowOnError extends boolean = true>(options?: Options<TrustListControllerGetAllTrustListsData, ThrowOnError>): RequestResult<TrustListControllerGetAllTrustListsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TrustListControllerGetAllTrustListsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list',
    ...options
});

/**
 * Creates a new trust list for the tenant
 */
export const trustListControllerCreateTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerCreateTrustListData, ThrowOnError>): RequestResult<TrustListControllerCreateTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).post<TrustListControllerCreateTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes a trust list
 */
export const trustListControllerDeleteTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerDeleteTrustListData, ThrowOnError>): RequestResult<TrustListControllerDeleteTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).delete<TrustListControllerDeleteTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}',
    ...options
});

/**
 * Returns the trust list by id for the tenant
 */
export const trustListControllerGetTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerGetTrustListData, ThrowOnError>): RequestResult<TrustListControllerGetTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerGetTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}',
    ...options
});

/**
 * Updates a trust list with new entities
 * Creates a new version for audit and regenerates the JWT
 */
export const trustListControllerUpdateTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerUpdateTrustListData, ThrowOnError>): RequestResult<TrustListControllerUpdateTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).put<TrustListControllerUpdateTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports the trust list in LoTE format
 */
export const trustListControllerExportTrustList = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerExportTrustListData, ThrowOnError>): RequestResult<TrustListControllerExportTrustListResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerExportTrustListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}/export',
    ...options
});

/**
 * Returns the version history for a trust list
 */
export const trustListControllerGetTrustListVersions = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerGetTrustListVersionsData, ThrowOnError>): RequestResult<TrustListControllerGetTrustListVersionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerGetTrustListVersionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}/versions',
    ...options
});

/**
 * Returns a specific version of a trust list
 */
export const trustListControllerGetTrustListVersion = <ThrowOnError extends boolean = true>(options: Options<TrustListControllerGetTrustListVersionData, ThrowOnError>): RequestResult<TrustListControllerGetTrustListVersionResponses, unknown, ThrowOnError> => (options.client ?? client).get<TrustListControllerGetTrustListVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/trust-list/{id}/versions/{versionId}',
    ...options
});

/**
 * Get cache statistics
 *
 * Returns statistics about the trust list and status list caches.
 */
export const cacheControllerGetStats = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerGetStatsData, ThrowOnError>): RequestResult<CacheControllerGetStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CacheControllerGetStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache/stats',
    ...options
});

/**
 * Clear all caches
 *
 * Clears both trust list and status list caches. Next verification will fetch fresh data.
 */
export const cacheControllerClearAllCaches = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerClearAllCachesData, ThrowOnError>): RequestResult<CacheControllerClearAllCachesResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CacheControllerClearAllCachesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache',
    ...options
});

/**
 * Clear trust list cache
 *
 * Clears the trust list cache. Next verification will fetch fresh trust lists.
 */
export const cacheControllerClearTrustListCache = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerClearTrustListCacheData, ThrowOnError>): RequestResult<CacheControllerClearTrustListCacheResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CacheControllerClearTrustListCacheResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache/trust-list',
    ...options
});

/**
 * Clear status list cache
 *
 * Clears the status list (revocation) cache. Next status check will fetch fresh status lists.
 */
export const cacheControllerClearStatusListCache = <ThrowOnError extends boolean = true>(options?: Options<CacheControllerClearStatusListCacheData, ThrowOnError>): RequestResult<CacheControllerClearStatusListCacheResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CacheControllerClearStatusListCacheResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/cache/status-list',
    ...options
});

/**
 * Get issuance configuration
 */
export const issuanceConfigControllerGetIssuanceConfigurations = <ThrowOnError extends boolean = true>(options?: Options<IssuanceConfigControllerGetIssuanceConfigurationsData, ThrowOnError>): RequestResult<IssuanceConfigControllerGetIssuanceConfigurationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<IssuanceConfigControllerGetIssuanceConfigurationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/config',
    ...options
});

/**
 * Create or replace issuance configuration
 */
export const issuanceConfigControllerStoreIssuanceConfiguration = <ThrowOnError extends boolean = true>(options: Options<IssuanceConfigControllerStoreIssuanceConfigurationData, ThrowOnError>): RequestResult<IssuanceConfigControllerStoreIssuanceConfigurationResponses, unknown, ThrowOnError> => (options.client ?? client).post<IssuanceConfigControllerStoreIssuanceConfigurationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reissue issuer registration certificate
 *
 * Bypasses and refreshes the issuer registration certificate cache, revoking the previous active certificate when replaced.
 */
export const issuanceConfigControllerReissueRegistrationCertificate = <ThrowOnError extends boolean = true>(options?: Options<IssuanceConfigControllerReissueRegistrationCertificateData, ThrowOnError>): RequestResult<IssuanceConfigControllerReissueRegistrationCertificateResponses, IssuanceConfigControllerReissueRegistrationCertificateErrors, ThrowOnError> => (options?.client ?? client).post<IssuanceConfigControllerReissueRegistrationCertificateResponses, IssuanceConfigControllerReissueRegistrationCertificateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/config/registration-cert/reissue',
    ...options
});

/**
 * Publish TS11 schema metadata via registrar
 *
 * Builds multipart schema metadata input (metadata JSON + rulebook + schema files) and submits it to the registrar, which builds and signs the final schema metadata.
 */
export const schemaMetadataControllerPublishSchemaMetadata = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerPublishSchemaMetadataData, ThrowOnError>): RequestResult<SchemaMetadataControllerPublishSchemaMetadataResponses, SchemaMetadataControllerPublishSchemaMetadataErrors, ThrowOnError> => (options.client ?? client).post<SchemaMetadataControllerPublishSchemaMetadataResponses, SchemaMetadataControllerPublishSchemaMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish a new version of an existing schema metadata entry
 *
 * Submits schema metadata input values for a new version under an existing schema ID. Registrar builds and signs the resulting schema metadata.
 */
export const schemaMetadataControllerPublishSchemaMetadataVersion = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerPublishSchemaMetadataVersionData, ThrowOnError>): RequestResult<SchemaMetadataControllerPublishSchemaMetadataVersionResponses, SchemaMetadataControllerPublishSchemaMetadataVersionErrors, ThrowOnError> => (options.client ?? client).post<SchemaMetadataControllerPublishSchemaMetadataVersionResponses, SchemaMetadataControllerPublishSchemaMetadataVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/publish-version',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get predefined schema metadata vocabularies
 */
export const schemaMetadataControllerGetVocabularies = <ThrowOnError extends boolean = true>(options?: Options<SchemaMetadataControllerGetVocabulariesData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetVocabulariesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SchemaMetadataControllerGetVocabulariesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/vocabularies',
    ...options
});

/**
 * List schema metadata
 */
export const schemaMetadataControllerFindAll = <ThrowOnError extends boolean = true>(options?: Options<SchemaMetadataControllerFindAllData, ThrowOnError>): RequestResult<SchemaMetadataControllerFindAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SchemaMetadataControllerFindAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata',
    ...options
});

/**
 * List schema metadata controlled by the user
 */
export const schemaMetadataControllerGetMine = <ThrowOnError extends boolean = true>(options?: Options<SchemaMetadataControllerGetMineData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetMineResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SchemaMetadataControllerGetMineResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/mine',
    ...options
});

/**
 * Get schema metadata by ID
 */
export const schemaMetadataControllerFindOne = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerFindOneData, ThrowOnError>): RequestResult<SchemaMetadataControllerFindOneResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerFindOneResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}',
    ...options
});

/**
 * Delete schema metadata
 */
export const schemaMetadataControllerRemove = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerRemoveData, ThrowOnError>): RequestResult<SchemaMetadataControllerRemoveResponses, unknown, ThrowOnError> => (options.client ?? client).delete<SchemaMetadataControllerRemoveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}',
    ...options
});

/**
 * Update schema metadata attributes
 */
export const schemaMetadataControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerUpdateData, ThrowOnError>): RequestResult<SchemaMetadataControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<SchemaMetadataControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get latest version of schema metadata by ID
 */
export const schemaMetadataControllerGetLatest = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetLatestData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetLatestResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetLatestResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/latest',
    ...options
});

/**
 * List all versions of a schema metadata entry
 */
export const schemaMetadataControllerGetVersions = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetVersionsData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetVersionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetVersionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions',
    ...options
});

/**
 * Get signed schema metadata JWT
 */
export const schemaMetadataControllerGetJwt = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetJwtData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetJwtResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetJwtResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}/jwt',
    ...options
});

/**
 * Get schema content for a specific format
 */
export const schemaMetadataControllerGetSchema = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerGetSchemaData, ThrowOnError>): RequestResult<SchemaMetadataControllerGetSchemaResponses, unknown, ThrowOnError> => (options.client ?? client).get<SchemaMetadataControllerGetSchemaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}/schemas/{format}',
    ...options
});

/**
 * Deprecate a schema metadata version
 */
export const schemaMetadataControllerDeprecateVersion = <ThrowOnError extends boolean = true>(options: Options<SchemaMetadataControllerDeprecateVersionData, ThrowOnError>): RequestResult<SchemaMetadataControllerDeprecateVersionResponses, unknown, ThrowOnError> => (options.client ?? client).patch<SchemaMetadataControllerDeprecateVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema-metadata/{id}/versions/{version}/deprecation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all webhook endpoints for the tenant.
 */
export const webhookEndpointControllerGetAll = <ThrowOnError extends boolean = true>(options?: Options<WebhookEndpointControllerGetAllData, ThrowOnError>): RequestResult<WebhookEndpointControllerGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WebhookEndpointControllerGetAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints',
    ...options
});

/**
 * Create a new webhook endpoint
 */
export const webhookEndpointControllerCreate = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerCreateData, ThrowOnError>): RequestResult<WebhookEndpointControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<WebhookEndpointControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a webhook endpoint
 */
export const webhookEndpointControllerDelete = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerDeleteData, ThrowOnError>): RequestResult<WebhookEndpointControllerDeleteResponses, WebhookEndpointControllerDeleteErrors, ThrowOnError> => (options.client ?? client).delete<WebhookEndpointControllerDeleteResponses, WebhookEndpointControllerDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints/{id}',
    ...options
});

/**
 * Get a webhook endpoint by ID
 */
export const webhookEndpointControllerGetById = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerGetByIdData, ThrowOnError>): RequestResult<WebhookEndpointControllerGetByIdResponses, WebhookEndpointControllerGetByIdErrors, ThrowOnError> => (options.client ?? client).get<WebhookEndpointControllerGetByIdResponses, WebhookEndpointControllerGetByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints/{id}',
    ...options
});

/**
 * Update a webhook endpoint
 */
export const webhookEndpointControllerUpdate = <ThrowOnError extends boolean = true>(options: Options<WebhookEndpointControllerUpdateData, ThrowOnError>): RequestResult<WebhookEndpointControllerUpdateResponses, WebhookEndpointControllerUpdateErrors, ThrowOnError> => (options.client ?? client).patch<WebhookEndpointControllerUpdateResponses, WebhookEndpointControllerUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/webhook-endpoints/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an offer for a credential.
 */
export const credentialOfferControllerGetOffer = <ThrowOnError extends boolean = true>(options: Options<CredentialOfferControllerGetOfferData, ThrowOnError>): RequestResult<CredentialOfferControllerGetOfferResponses, unknown, ThrowOnError> => (options.client ?? client).post<CredentialOfferControllerGetOfferResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/offer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete a deferred credential transaction
 *
 * Completes a pending deferred credential transaction by providing the claims. The credential will be generated and marked as ready for wallet retrieval.
 */
export const deferredControllerCompleteDeferred = <ThrowOnError extends boolean = true>(options: Options<DeferredControllerCompleteDeferredData, ThrowOnError>): RequestResult<DeferredControllerCompleteDeferredResponses, DeferredControllerCompleteDeferredErrors, ThrowOnError> => (options.client ?? client).post<DeferredControllerCompleteDeferredResponses, DeferredControllerCompleteDeferredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/deferred/{transactionId}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fail a deferred credential transaction
 *
 * Marks a deferred credential transaction as failed. The wallet will receive an invalid_transaction_id error when attempting retrieval.
 */
export const deferredControllerFailDeferred = <ThrowOnError extends boolean = true>(options: Options<DeferredControllerFailDeferredData, ThrowOnError>): RequestResult<DeferredControllerFailDeferredResponses, DeferredControllerFailDeferredErrors, ThrowOnError> => (options.client ?? client).post<DeferredControllerFailDeferredResponses, DeferredControllerFailDeferredErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/issuer/deferred/{transactionId}/fail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pushed Authorization Request
 *
 * Submit wallet authorization request parameters for the VP-backed AS.
 */
export const chainedAsVpControllerPar = <ThrowOnError extends boolean = true>(options: Options<ChainedAsVpControllerParData, ThrowOnError>): RequestResult<ChainedAsVpControllerParResponses, ChainedAsVpControllerParErrors, ThrowOnError> => (options.client ?? client).post<ChainedAsVpControllerParResponses, ChainedAsVpControllerParErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/issuers/{tenantId}/chained-as-vp/par',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Authorization endpoint
 *
 * Validates the request_uri and redirects the browser into an OID4VP wallet request.
 */
export const chainedAsVpControllerAuthorize = <ThrowOnError extends boolean = true>(options: Options<ChainedAsVpControllerAuthorizeData, ThrowOnError>): RequestResult<unknown, ChainedAsVpControllerAuthorizeErrors, ThrowOnError> => (options.client ?? client).get<unknown, ChainedAsVpControllerAuthorizeErrors, ThrowOnError>({ url: '/api/issuers/{tenantId}/chained-as-vp/authorize', ...options });

/**
 * Verifier callback
 *
 * Receives the OID4VP verifier redirect and finishes the OAuth authorization flow.
 */
export const chainedAsVpControllerVpCallback = <ThrowOnError extends boolean = true>(options: Options<ChainedAsVpControllerVpCallbackData, ThrowOnError>): RequestResult<unknown, ChainedAsVpControllerVpCallbackErrors, ThrowOnError> => (options.client ?? client).get<unknown, ChainedAsVpControllerVpCallbackErrors, ThrowOnError>({ url: '/api/issuers/{tenantId}/chained-as-vp/vp-callback', ...options });

/**
 * Token endpoint
 *
 * Exchanges the authorization code for an access token containing issuer_state.
 */
export const chainedAsVpControllerToken = <ThrowOnError extends boolean = true>(options: Options<ChainedAsVpControllerTokenData, ThrowOnError>): RequestResult<ChainedAsVpControllerTokenResponses, ChainedAsVpControllerTokenErrors, ThrowOnError> => (options.client ?? client).post<ChainedAsVpControllerTokenResponses, ChainedAsVpControllerTokenErrors, ThrowOnError>({
    url: '/api/issuers/{tenantId}/chained-as-vp/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an presentation request that can be sent to the user
 */
export const verifierOfferControllerGetOffer = <ThrowOnError extends boolean = true>(options: Options<VerifierOfferControllerGetOfferData, ThrowOnError>): RequestResult<VerifierOfferControllerGetOfferResponses, unknown, ThrowOnError> => (options.client ?? client).post<VerifierOfferControllerGetOfferResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/verifier/offer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload files that belong to a tenant like images
 */
export const storageControllerUpload = <ThrowOnError extends boolean = true>(options: Options<StorageControllerUploadData, ThrowOnError>): RequestResult<StorageControllerUploadResponses, unknown, ThrowOnError> => (options.client ?? client).post<StorageControllerUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/storage',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Export the current tenant configuration
 */
export const configPortabilityControllerExport = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerExportData, ThrowOnError>): RequestResult<ConfigPortabilityControllerExportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConfigPortabilityControllerExportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/export',
    ...options
});

/**
 * Plan and validate a tenant configuration import
 */
export const configPortabilityControllerPlan = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerPlanData, ThrowOnError>): RequestResult<ConfigPortabilityControllerPlanResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ConfigPortabilityControllerPlanResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/plan',
    ...options
});

/**
 * Plan an import from a configuration ZIP
 */
export const configPortabilityControllerPlanArchive = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerPlanArchiveData, ThrowOnError>): RequestResult<ConfigPortabilityControllerPlanArchiveResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ConfigPortabilityControllerPlanArchiveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/plan/archive',
    ...options
});

/**
 * Apply a validated tenant configuration bundle
 */
export const configPortabilityControllerImport = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerImportData, ThrowOnError>): RequestResult<ConfigPortabilityControllerImportResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerImportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/import',
    ...options
});

/**
 * Apply a configuration ZIP
 */
export const configPortabilityControllerImportArchive = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerImportArchiveData, ThrowOnError>): RequestResult<ConfigPortabilityControllerImportArchiveResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerImportArchiveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/import/archive',
    ...options
});

/**
 * List recent configuration operations
 */
export const configPortabilityControllerOperations = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerOperationsData, ThrowOnError>): RequestResult<ConfigPortabilityControllerOperationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConfigPortabilityControllerOperationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/operations',
    ...options
});

/**
 * Read a durable configuration operation report
 */
export const configPortabilityControllerOperation = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerOperationData, ThrowOnError>): RequestResult<ConfigPortabilityControllerOperationResponses, unknown, ThrowOnError> => (options.client ?? client).get<ConfigPortabilityControllerOperationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/operations/{id}',
    ...options
});

/**
 * Release an interrupted operation after its worker has been stopped
 */
export const configPortabilityControllerAcknowledgeInterruption = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerAcknowledgeInterruptionData, ThrowOnError>): RequestResult<ConfigPortabilityControllerAcknowledgeInterruptionResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerAcknowledgeInterruptionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/operations/{id}/acknowledge-interruption',
    ...options
});

/**
 * Upgrade one configuration document
 */
export const configPortabilityControllerUpgrade = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerUpgradeData, ThrowOnError>): RequestResult<ConfigPortabilityControllerUpgradeResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ConfigPortabilityControllerUpgradeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/documents/upgrade',
    ...options
});

/**
 * List configuration resource ownership
 */
export const configPortabilityControllerResources = <ThrowOnError extends boolean = true>(options?: Options<ConfigPortabilityControllerResourcesData, ThrowOnError>): RequestResult<ConfigPortabilityControllerResourcesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConfigPortabilityControllerResourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources',
    ...options
});

/**
 * Detach a resource from file provisioning
 */
export const configPortabilityControllerDetach = <ThrowOnError extends boolean = true>(options: Options<ConfigPortabilityControllerDetachData, ThrowOnError>): RequestResult<ConfigPortabilityControllerDetachResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfigPortabilityControllerDetachResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/config-bundles/resources/{kind}/{id}/detach',
    ...options
});
